<template>
  <Dialog :title="dialogTitle" v-model="dialogVisible">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="formRules"
      label-width="100px"
      v-loading="formLoading"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="formData.name" maxlength="100" placeholder="请输入产品名称" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="负责人" prop="ownerUserId">
            <el-select
              v-model="formData.ownerUserId"
              placeholder="请选择负责人"
              :disabled="formData.id"
              class="w-1/1"
            >
              <el-option
                v-for="user in userList"
                :key="user.id"
                :label="user.nickname"
                :value="user.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编号" prop="no">
            <el-input v-model="formData.no" maxlength="20" placeholder="请输入编号（产品编码）" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品类型" prop="categoryId">
            <el-cascader
              v-model="formData.categoryId"
              :options="productCategoryList"
              :props="defaultProps"
              class="w-1/1"
              clearable
              placeholder="请选择产品类型"
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品单位" prop="unit">
            <el-select v-model="formData.unit" class="w-1/1" placeholder="请选择单位">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_PRODUCT_UNIT)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="价格" prop="price">
            <el-input-number
              v-model="formData.price"
              placeholder="请输入价格"
              :min="0"
              :precision="2"
              :step="0.1"
              class="w-full!"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品描述" prop="description">
            <el-input v-model="formData.description" maxlength="100" placeholder="请输入产品描述" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上架状态" prop="status">
            <el-select v-model="formData.status" placeholder="请选择状态" class="w-1/1">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_PRODUCT_STATUS)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 以下为老系统「产品详情」的演示站资料字段 -->
        <el-col :span="12">
          <el-form-item label="演示网址" prop="demoUrl">
            <el-input v-model="formData.demoUrl" maxlength="512" placeholder="请输入演示网址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="演示站名称" prop="demoSiteName">
            <el-input
              v-model="formData.demoSiteName"
              maxlength="255"
              placeholder="请输入演示站名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="demoStatus">
            <el-select
              v-model="formData.demoStatus"
              placeholder="请选择状态"
              clearable
              class="w-1/1"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_PRODUCT_DEMO_STATUS)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="端口" prop="port">
            <el-input v-model="formData.port" maxlength="255" placeholder="请输入端口" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" prop="industry">
            <el-select v-model="formData.industry" placeholder="请选择行业" clearable class="w-1/1">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_PRODUCT_INDUSTRY)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="应用场景" prop="applicationScene">
            <el-select
              v-model="formData.applicationScene"
              placeholder="请选择应用场景"
              clearable
              class="w-1/1"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_PRODUCT_APPLICATION_SCENE)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开发语言" prop="devLanguage">
            <el-input v-model="formData.devLanguage" maxlength="128" placeholder="请输入开发语言" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据库" prop="databaseName">
            <el-input v-model="formData.databaseName" maxlength="128" placeholder="请输入数据库" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="二维码" prop="qrcode">
            <!-- 二维码是产品专属图片，不属于运营素材，直接上传 -->
            <UploadImg
              v-model="formData.qrcode"
              width="120px"
              height="120px"
              :use-material-library="false"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="报价" prop="quotation">
            <el-input
              v-model="formData.quotation"
              type="textarea"
              :rows="2"
              placeholder="请输入报价"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="产品介绍" prop="introduction">
            <el-input
              v-model="formData.introduction"
              type="textarea"
              :rows="4"
              placeholder="请输入产品介绍"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="演示网址与账号密码" prop="demoAccount">
            <el-input
              v-model="formData.demoAccount"
              type="textarea"
              :rows="3"
              placeholder="请输入演示网址与账号密码"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button @click="submitForm" type="primary" :disabled="formLoading">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>
<script setup lang="ts">
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import * as ProductApi from '@/api/crm/product'
import * as ProductCategoryApi from '@/api/crm/product/category'
import { defaultProps, handleTree } from '@/utils/tree'
import { getSimpleUserList, UserVO } from '@/api/system/user'
import { getCurrentUserId } from '@/utils/auth'

defineOptions({ name: 'CrmProductForm' })

const { t } = useI18n() // 国际化
const message = useMessage() // 消息弹窗

const dialogVisible = ref(false) // 弹窗的是否展示
const dialogTitle = ref('') // 弹窗的标题
const formLoading = ref(false) // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
const formType = ref('') // 表单的类型：create - 新增；update - 修改
const userId = getCurrentUserId() // 当前登录的编号
const formData = ref({
  id: undefined,
  name: undefined,
  demoSiteName: undefined,
  demoUrl: undefined,
  demoStatus: undefined,
  port: undefined,
  industry: undefined,
  applicationScene: undefined,
  devLanguage: undefined,
  databaseName: undefined,
  qrcode: '',
  quotation: undefined,
  introduction: undefined,
  demoAccount: undefined,
  no: undefined,
  unit: undefined,
  price: Number(undefined),
  status: undefined,
  categoryId: undefined,
  description: undefined,
  ownerUserId: -1
})
const formRules = reactive({
  name: [{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
  demoUrl: [{ required: true, message: '演示网址不能为空', trigger: 'blur' }],
  no: [{ required: true, message: '编号不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }],
  categoryId: [{ required: true, message: '产品分类ID不能为空', trigger: 'blur' }],
  ownerUserId: [{ required: true, message: '负责人不能为空', trigger: 'blur' }],
  price: [{ required: true, message: '价格不能为空', trigger: 'blur' }]
})

const formRef = ref() // 表单 Ref

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  // 修改时，设置数据
  if (id) {
    formLoading.value = true
    try {
      formData.value = await ProductApi.getProduct(id)
    } finally {
      formLoading.value = false
    }
  } else {
    formData.value.ownerUserId = userId
  }
}
defineExpose({ open }) // 提供 open 方法，用于打开弹窗

/** 提交表单 */
const emit = defineEmits(['success']) // 定义 success 事件，用于操作成功后的回调
const submitForm = async () => {
  // 校验表单
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  // 提交请求
  formLoading.value = true
  try {
    const data = formData.value as unknown as ProductApi.ProductVO
    if (formType.value === 'create') {
      await ProductApi.createProduct(data)
      message.success(t('common.createSuccess'))
    } else {
      await ProductApi.updateProduct(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    // 发送操作成功的事件
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 重置表单 */
const resetForm = () => {
  formData.value = {
    id: undefined,
    name: undefined,
    demoSiteName: undefined,
    demoUrl: undefined,
    demoStatus: undefined,
    port: undefined,
    industry: undefined,
    applicationScene: undefined,
    devLanguage: undefined,
    databaseName: undefined,
    qrcode: '',
    quotation: undefined,
    introduction: undefined,
    demoAccount: undefined,
    no: undefined,
    unit: undefined,
    price: Number(undefined),
    status: undefined,
    categoryId: undefined,
    description: undefined,
    ownerUserId: -1
  }
  formRef.value?.resetFields()
}

/** 初始化 */
const productCategoryList = ref<any[]>([]) // 产品分类树
const userList = ref<UserVO[]>([]) // 系统用户
onMounted(async () => {
  // 产品分类树
  const data = await ProductCategoryApi.getProductCategoryList({})
  productCategoryList.value = handleTree(data, 'id', 'parentId')
  // 系统用户列表
  userList.value = await getSimpleUserList()
})
</script>
